/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, July 7th 2022, 11:28:16 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { TaskTemplate } from "lib/schemas";
import { COLORSCHEME } from "theme/styles";
import { EmphasisText, InputHelpDialogWrapper } from "ui-widgets";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { TaskTemplateInput } from "./TaskTemplateInput";

export const NextNodeSetting = () => {
  const { watch } = useOSFormContext<TaskTemplate>();
  const [processDefinitionId, taskType, title, next_id] = watch<(keyof TaskTemplate)[]>([
    "process",
    "type",
    "title",
    "next",
  ]) as [TaskTemplate["process"], TaskTemplate["type"], TaskTemplate["title"], TaskTemplate["next"]];

  const hasNext = (taskType !== "Split" && taskType !== "End") || Boolean(next_id);

  return hasNext ? (
    <InputHelpDialogWrapper
      helpTitle={<>Next step in the workflow</>}
      helpContent={
        <>
          <p>
            This configuration will determine the next step to be taken in your workflow after the{" "}
            <EmphasisText>{title}</EmphasisText> step is complete. Make sure you have created the required step as per
            your workflow design using the drag and drop tool on the left side bar.
          </p>
          <p>
            <EmphasisText color={COLORSCHEME.success}>
              Tip: You can also use the flowchart view to connect one step to another.
            </EmphasisText>
          </p>
        </>
      }
    >
      <TaskTemplateInput<TaskTemplate>
        apiQueryParams={{ process_definition: processDefinitionId }}
        schema_field_key="next"
        label="Next Step"
      />
    </InputHelpDialogWrapper>
  ) : null;
};
